import * as st from '../state/store';
import { toUrl } from '../state/url';

/** Authoring aid for tours (F11): copies the current view as a v=1 query. Rendered in dev builds only. */
export function CopyViewState() {
  if (!import.meta.env.DEV) return null;
  const copy = () => {
    const q = toUrl({ selected: null, camera: st.camera.value, layers: st.layers.value, hidden: st.hidden.value, isolate: st.isolate.value }).split('?')[1];
    void navigator.clipboard?.writeText(q);
    st.showToast('View state copied');
  };
  return (
    <button type="button" class="btn small ghost" onClick={copy} data-testid="copy-view-state">
      Copy view state (dev)
    </button>
  );
}
